import React from 'react';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import NumberInput from './NumberInput';
import './Worksheet.scss';

function SummaryRow(props) {
  const { name, label, value, precision, onChange, readOnly } = props;
  return (
    <Row>
      <FormGroup controlId={name} className="formGroup form-inline form-group">
        <Col md={7}>
          <ControlLabel className="summary-row-label">{label}</ControlLabel>
        </Col>
        <Col md={2} className="text-right">
          <NumberInput
            name={name}
            value={value}
            precision={precision}
            onChange={onChange}
            readOnly={readOnly}
          />
        </Col>
      </FormGroup>
    </Row>
  );
}

SummaryRow.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.number,
  precision: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default SummaryRow;
